export const ADMINISTRACION_ENDPOINTS = {
    // Auth
    AUTH: {
        LOGIN: '/Administracion/Autenticacion',
        LOGOUT: '/Administracion/Autenticacion/logout',
        REFRESH_TOKEN: '/Administracion/Autenticacion/refresh-token',
        PROFILE: '/Administracion/Autenticacion/perfil',
        SOLICITAR_RECUPERACION: '/Administracion/Autenticacion/solicitar-recuperacion',
        RESTABLECER_CONTRASENA: '/Administracion/Autenticacion/restablecer-contrasena',
        VALIDAR_TOKEN: '/Administracion/Autenticacion/validar-token',
        VALIDATE_PASSWORD: '/Administracion/Autenticacion/validar-contrasena',
        ACTIVAR_CUENTA: '/Administracion/UsuarioActivacion/activar',
    },
    // Tipos de Usuario
    TIPOS_USUARIO: {
        BASE: '/Administracion/TiposUsuario',
        DETAIL: (id: number) => `/Administracion/TiposUsuario/${id}`,
    },
    // Roles
    ROLES: {
        BASE: '/Administracion/Roles',
        DETAIL: (id: number) => `/Administracion/Roles/${id}`,
        USUARIOS_POR_ROL: (id: number) => `/Administracion/Roles/${id}/usuarios`,
    },
    // Usuarios
    USUARIOS: {
        BASE: '/Administracion/usuarios',
        BY_ID: (id: bigint) => `/Administracion/usuarios/${id}`,
    },
} as const;
